import BlockOne from "../components/HomePage/BlockOne";
import ContactUsBlock from "../components/ContactUsBlock";
import { Helmet } from "react-helmet";
import BlockTwo from "../components/HomePage/BlockTwo";
import BlockThree from "../components/HomePage/BlockThree";
import BlockFore from "../components/HomePage/BlockFore";

const Home  = () => {
  return (
    <>
      <Helmet>
        <title>Welcome 365 Traveling</title>
        <meta
          name="description"
          content="Welcome 365 Traveling"
        />
        <meta
          name="keywords"
          content="Welcome 365 Traveling"
        />
      </Helmet>
      <div id="blockOne">
       <BlockOne />
      </div>
      <div id="blockTwo">
        <BlockTwo />
      </div>
      <div id="BlockThree">
        <BlockThree />
      </div>
      <div id="BlockFore">
        <BlockFore />
      </div>
      <div id="ContactUsBlock">
       <ContactUsBlock />
      </div>
    </>
  )
}
export default Home
